import { Entity } from './entity';

export type SaveLabelLanguage = 'en' | 'es' | 'pt' | 'fr' | 'it';

export type LabelLanguages = Partial<Record<SaveLabelLanguage, string>> & { en: string };

export interface LabelParameters {
  id?: string;
  uuid: string;
  value: string;
  lang: SaveLabelLanguage;
}

export class Label implements Entity {
  constructor(private attributes: LabelParameters) {}

  public get id(): string | undefined {
    return this.attributes.id;
  }

  public get uuid(): string {
    return this.attributes.uuid;
  }

  public get value(): string {
    return this.attributes.value;
  }

  public get lang(): string {
    return this.attributes.lang;
  }
}
